export const LANGUAGE_KEYS = {
  RU: "RU",
  EN: "EN",
  UZ: "UZ",
  KZ: "KZ",
  GE: "GE",
} as const;
